import * as EnvConstants from './envConstants';

export const getEnvVariable = (key: keyof typeof window._env_) => {
  return (
    EnvConstants[`VITE_${key}`] ??
    (window._env_?.[key] ?? '').replace(/^"|"$/g, '')
  ); // dequote surrounding quotes
};
